import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { CashVoucherPopupService } from '../../service/cash-voucher-popup/cash-voucher-popup.service';

const CASH_VOUCHER_URLS: Record<string, string> = {
  en: 'https://www.takeme.com/en-restaurants-accepting-cash-vouchers/',
  ja: 'https://www.takeme.com/jp-restaurants-accepting-cash-vouchers/',
  'zh-CN': 'https://www.takeme.com/cn-restaurants-accepting-cash-vouchers/',
  'zh-TW': 'https://www.takeme.com/cntra-restaurants-accepting-cash-vouchers/',
  ko: 'https://www.takeme.com/ko-restaurants-accepting-cash-vouchers/',
};

const POPUP_IMAGES: Record<string, string> = {
  en: 'assets/images/cash-voucher-popup-en.png',
  ja: 'assets/images/cash-voucher-popup-ja.png',
  'zh-CN': 'assets/images/cash-voucher-popup-zh-CN.png',
  'zh-TW': 'assets/images/cash-voucher-popup-zh-TW.png',
  ko: 'assets/images/cash-voucher-popup-ko.png',
};

@Component({
  selector: 'app-cash-voucher-popup',
  standalone: true,
  template: `
    <div style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:1060;display:flex;align-items:center;justify-content:center"
         (click)="dismiss()">
      <div style="position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5)"></div>
      <div style="position:relative" class="flex flex-col items-center">
        <img [src]="imageSrc"
             alt="Cash Voucher"
             class="w-[340px] max-w-[80vw] cursor-pointer"
             (click)="claim($event)">
        <div class="w-[340px] max-w-[80vw] mt-3 flex justify-center">
          <button class="border-none bg-transparent p-0 cursor-pointer" (click)="dismiss()">
            <img src="assets/images/cash-voucher-close.svg" alt="Close" class="w-9 h-9">
          </button>
        </div>
      </div>
    </div>
  `,
})
export class CashVoucherPopupComponent implements OnInit, OnDestroy {
  imageSrc: string;
  private voucherUrl: string;

  constructor(
    private el: ElementRef,
    private translocoService: TranslocoService,
    private popupService: CashVoucherPopupService,
  ) {
    const lang = this.translocoService.getActiveLang();
    this.imageSrc = POPUP_IMAGES[lang] || POPUP_IMAGES['en'];
    this.voucherUrl = CASH_VOUCHER_URLS[lang] || CASH_VOUCHER_URLS['en'];
  }

  ngOnInit(): void {
    document.body.appendChild(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.el.nativeElement.remove();
  }

  claim(event: Event): void {
    event.stopPropagation();
    this.popupService.close();
    window.open(this.voucherUrl, '_blank');
  }

  dismiss(): void {
    this.popupService.close();
  }
}
